export class TimeFrameMatching {

    constructor(matching: any) {
        this.total = new SumRow(matching.total);
        for (let o of matching.sumRows) {
            this.sumRows.push(new SumRow(o));
        }
    }

    total: SumRow;
    sumRows = new Array<SumRow>();
}

export class SumRow {

    constructor(sumRow: any) {
        this.carrier = sumRow.carrier;
        this.date = sumRow.date;
        this.totalTransports = sumRow.totalTransports;
        this.withTimeslotBooking = sumRow.withTimeslotBooking;
        this.percentageWithTimeslotBooking = sumRow.percentageWithTimeslotBooking;
        this.countEarly = sumRow.countEarly;
        this.percentageEarly = sumRow.percentageEarly;
        this.countInTime = sumRow.countInTime;
        this.percentageInTime = sumRow.percentageInTime;
        this.countDelayed = sumRow.countDelayed;
        this.percentageDelayed = sumRow.percentageDelayed;
        this.countLate = sumRow.countLate;
        this.percentageLate = sumRow.percentageLate;
        this.countNotArrived = sumRow.countNotArrived;
        this.percentageNotArrived = sumRow.percentageNotArrived;
        this.countNotYetArrived = sumRow.countNotYetArrived;
        this.percentageNotYetArrived = sumRow.percentageNotYetArrived;
        this.countOther = sumRow.countOther;
        this.percentageOther = sumRow.percentageOther;
    }

    carrier: string;

    date: string;

    totalTransports: number;

    withTimeslotBooking: number;
    percentageWithTimeslotBooking: number;

    countEarly: number;
    percentageEarly: number;

    countInTime: number;
    percentageInTime: number;

    countDelayed: number;
    percentageDelayed: number;

    countLate: number;
    percentageLate: number;

    countNotArrived: number;
    percentageNotArrived: number;

    countNotYetArrived: number;
    percentageNotYetArrived: number;

    countOther: number;
    percentageOther: number;

}